import "./About.css"
import React from 'react'
import Container from "../../containers/Container";

const MobileApps = () => {
    return (
        <Container>
            <div className="container top">
                <h1>Мобильные приложения</h1>
            </div>
        </Container>
    )
}

export default MobileApps;